import { render, staticRenderFns } from "./MppAppTabbar.vue?vue&type=template&id=5fde5ffb&scoped=true"
import script from "./MppAppTabbar.vue?vue&type=script&lang=js"
export * from "./MppAppTabbar.vue?vue&type=script&lang=js"
import style0 from "./MppAppTabbar.vue?vue&type=style&index=0&id=5fde5ffb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fde5ffb",
  null
  
)

export default component.exports